import { NIcon, type MenuOption } from "naive-ui";
import CustomSVG from "@/components/custom/CustomSVG.vue";
import SvgIcon from "@/components/outter/svg-icon.vue";
import { h } from "vue";
import tools from "@/utils/tools";

const consoleURLPrefix = "/console";
const headIcon = h(
  "i",
  {
    class: ["fa-solid", "fa-terminal", "logo-icon"],
    style: {
      fontSize: "1.8rem",
      color: "var(--theme-color)",
    },
    onClick: () => {
      tools.jumptoLocal(`/post-release`);
    },
  },
  { default: () => h(CustomSVG, { icon: "Terminal" }) }
);
const menuOptions: MenuOption[] = [
  {
    label: "博客中控后台",
    name: "console-home",
    key: "blog-admin",
    iconVNode: headIcon,
  },
  {
    label: "文章发布",
    key: "post-release",
    name: "post-release", // 路由名称
    iconVNode: h(NIcon, null, {
      default: () => h(CustomSVG, { icon: "DynFileDocumentPlus" }),
    }),
  },
  {
    label: "文章管理",
    key: "post-manager",
    name: "post-manager",
    iconVNode: h(NIcon, null, {
      default: () => h(CustomSVG, { icon: "DynDocumentCode" }),
    }),
  },
  {
    label: "随记发布",
    key: "note-release",
    name: "note-release",
    iconVNode: h(NIcon, null, {
      default: () => h(CustomSVG, { icon: "DynCoffee" }),
    }),
  },
  {
    label: "随记管理",
    key: "note-manager",
    name: "note-manager",
    iconVNode: h(NIcon, null, {
      default: () => h(CustomSVG, { icon: "DynEdit" }),
    }),
  },
  {
    label: "网站概览",
    key: "dashboard",
    name: "dashboard",
    iconVNode: h(NIcon, null, {
      // default: () => h(CustomSVG, { icon: "BookmarkOutline" }),
      default: () => h(CustomSVG, { icon: "DynTextBoxMultiple" }),
    }),
  },
];

export { menuOptions, headIcon, consoleURLPrefix };
